import React from 'react';
import { MessageType } from '@/types/system-message-templates';
import { useSystemMessagePreview } from '@/hooks/useSystemMessagePreview';
import { Loader2 } from 'lucide-react';

interface SystemMessagePreviewProps {
  messageType: MessageType;
  templateContent: string;
}

export function SystemMessagePreview({ messageType, templateContent }: SystemMessagePreviewProps) {
  const { data: preview, isLoading } = useSystemMessagePreview({
    messageType,
    template_content: templateContent,
  });

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 h-full flex flex-col overflow-hidden">
      <div className="bg-[#F5F5F5] rounded-lg p-3 flex-1 overflow-y-auto">
        {isLoading ? (
          <div className="flex items-center justify-center h-full">
            <Loader2 className="w-6 h-6 text-[#5B8E87] animate-spin" />
          </div>
        ) : preview ? (
          <div className="bg-white rounded-lg shadow-sm p-4 relative">
            {/* WhatsApp-style message bubble */}
            <div className="bg-[#E7F7E5] rounded-lg p-3 rounded-tl-none">
              <pre className="whitespace-pre-wrap text-sm text-[#212121] font-sans">
                {preview}
              </pre>
            </div>
            <div className="text-xs text-gray-500 mt-1 text-right">
              {new Date().toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
              })}
            </div>
          </div>
        ) : (
          <div className="flex items-center justify-center h-full text-gray-500 text-sm">
            Start typing to see preview
          </div>
        )}
      </div>
    </div>
  );
}
